var _g, _circle, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup41946(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_41946",
    "data-name": "Group 41946",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.646,
    height: 71.643,
    viewBox: "0 0 64.646 71.643",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41945",
    "data-name": "Group 41945",
    transform: "translate(0 4.508)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41939",
    "data-name": "Group 41939",
    transform: "translate(0 51.481)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2374",
    "data-name": "Path 2374",
    d: "M207.9,22.617a2.2,2.2,0,1,1-2.2,2.2A2.2,2.2,0,0,1,207.9,22.617Zm0,2.731a.535.535,0,1,0-.535-.536A.536.536,0,0,0,207.9,25.348Z",
    transform: "translate(-205.701 -22.617)",
    fill: "#ff7b00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41940",
    "data-name": "Group 41940",
    transform: "translate(8.412 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2375",
    "data-name": "Path 2375",
    d: "M315.5,110.412a.827.827,0,0,1,.587.243l1.874,1.874a.83.83,0,0,1,0,1.174l-1.874,1.874a.83.83,0,0,1-1.174,0l-1.874-1.874a.83.83,0,0,1,0-1.174l1.874-1.874A.827.827,0,0,1,315.5,110.412Zm.7,2.7-.7-.7-.7.7.7.7Z",
    transform: "translate(-312.792 -110.412)",
    fill: "#c5c5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41941",
    "data-name": "Group 41941",
    transform: "translate(44.098 61.726)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2376",
    "data-name": "Path 2376",
    d: "M45.12,317.648a.83.83,0,0,1,.587.243l1.874,1.874a.83.83,0,0,1,0,1.174l-1.874,1.874a.83.83,0,0,1-1.174,0l-1.874-1.874a.83.83,0,0,1,0-1.174l1.874-1.875A.83.83,0,0,1,45.12,317.648Zm.7,2.7-.7-.7-.7.7.7.7Z",
    transform: "translate(-42.415 -317.648)",
    fill: "#6583fe"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6974",
    "data-name": "Path 6974",
    d: "M19.787,132.239a1.377,1.377,0,0,0-1.377,1.377v1.377H17.033a1.377,1.377,0,1,0,0,2.754H18.41v1.377a1.377,1.377,0,1,0,2.754,0v-1.377h1.377a1.377,1.377,0,1,0,0-2.754H21.164v-1.377A1.377,1.377,0,0,0,19.787,132.239Z",
    transform: "translate(40.729 -124.954)",
    fill: "#ff7b00"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1919",
    "data-name": "Ellipse 1919",
    cx: 11.415,
    cy: 11.415,
    r: 11.415,
    transform: "translate(24.692 10.407)",
    fill: "#b3b3ff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "architectural",
    transform: "translate(7.569 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41944",
    "data-name": "Group 41944",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6975",
    "data-name": "Path 6975",
    d: "M235.273,132.533a3.339,3.339,0,1,0,3.339,3.339A3.343,3.343,0,0,0,235.273,132.533Zm0,4.6a1.258,1.258,0,1,1,1.258-1.258A1.259,1.259,0,0,1,235.273,137.13Z",
    transform: "translate(-206.756 -114.22)",
    fill: "#3335cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6976",
    "data-name": "Path 6976",
    d: "M106.6,69.22l-1.9-3.3a2.189,2.189,0,0,0,.25-.58l.419-1.564a2.167,2.167,0,0,0-.218-1.656L96.916,47.874h4.2a1.037,1.037,0,1,0,0-2.073h-5.4L86.935,30.586A12.486,12.486,0,0,0,81.544,9.611V2.182A2.184,2.184,0,0,0,79.362,0h-2.29a2.184,2.184,0,0,0-2.182,2.182V9.611A12.486,12.486,0,0,0,69.5,30.586L60.715,45.8h-5.4a1.037,1.037,0,1,0,0,2.073h4.2l-1.9,3.288a1.037,1.037,0,1,0,1.8,1.037L73.426,27.932a7.9,7.9,0,0,0,2.209,1.187L58.066,59.551,55.895,58.3l1.374-2.38a1.037,1.037,0,0,0-1.8-1.037l-4.182,7.244a2.167,2.167,0,0,0-.218,1.655l.419,1.564a2.188,2.188,0,0,0,.25.58l-1.9,3.3a1.037,1.037,0,1,0,1.8,1.037l1.9-3.3.058,0a2.2,2.2,0,0,0,.568-.075l1.564-.419a2.166,2.166,0,0,0,1.325-1.017l2.29-3.966h0L67.2,47.874H74.89v1.332a3.252,3.252,0,0,0,3.248,3.248H78.3a3.252,3.252,0,0,0,3.248-3.248V47.874h7.689L94.9,57.685a3.325,3.325,0,1,0,3.325,5.759l1.159,2.007a2.167,2.167,0,0,0,1.325,1.017l1.564.419a2.2,2.2,0,0,0,.568.075l.058,0,1.9,3.3a1.037,1.037,0,0,0,1.8-1.037ZM77.072,2.073h2.29a.109.109,0,0,1,.108.108v2.4H76.964v-2.4a.108.108,0,0,1,.108-.108Zm-.108,4.58h2.507V9.223q-.619-.062-1.253-.063t-1.253.063ZM67.8,21.647a10.414,10.414,0,1,1,18.054,7.074L84.524,26.41a7.907,7.907,0,1,0-12.613,0l-1.334,2.311A10.4,10.4,0,0,1,67.8,21.647Zm10.414,5.833a5.833,5.833,0,1,1,5.833-5.833A5.84,5.84,0,0,1,78.217,27.481Zm0,2.073c.145,0,.289,0,.432-.012L80.013,31.9a10.416,10.416,0,0,1-3.592,0l1.364-2.363C77.929,29.549,78.073,29.554,78.217,29.554ZM55.257,64.415a.109.109,0,0,1-.066.05l-1.564.419a.108.108,0,0,1-.133-.077l-.419-1.564a.109.109,0,0,1,.011-.082l1.772-3.069,2.171,1.253ZM79.471,49.206A1.176,1.176,0,0,1,78.3,50.381h-.157a1.176,1.176,0,0,1-1.175-1.175V46.839h0V43.363a.069.069,0,0,1,.069-.069H79.4a.069.069,0,0,1,.069.069ZM81.544,45.8V43.363A2.145,2.145,0,0,0,79.4,41.221H77.033a2.145,2.145,0,0,0-2.143,2.143V45.8H68.4l6.931-12a12.533,12.533,0,0,0,5.777,0l1.746,3.024a1.037,1.037,0,0,0,1.8-1.037L82.6,32.232a1.031,1.031,0,0,0-.187-.324L80.8,29.119a7.9,7.9,0,0,0,2.209-1.187L100.54,58.3l-1.109.641a3.334,3.334,0,0,0-2.365-1.644L86.795,39.5A1.037,1.037,0,0,0,85,40.54L88.037,45.8Zm14.993,16.03a1.253,1.253,0,1,1,1.253-1.253A1.255,1.255,0,0,1,96.538,61.831Zm4.705,2.634a.107.107,0,0,1-.066-.05l-1.532-2.653a3.289,3.289,0,0,0,.176-.656l1.754-1.013,1.772,3.069a.109.109,0,0,1,.011.082l-.419,1.564a.108.108,0,0,1-.133.077Z",
    transform: "translate(-49.7 0)",
    fill: "#3335cf"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup41946);
export default __webpack_public_path__ + "static/media/Group 41946.b367e7557b0d15ee3a1979998814a6b7.svg";
export { ForwardRef as ReactComponent };